import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { BONUS_TOTAL, OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-mist" data-id="element-53" data-mp="c7adc3u6m4g0">
      <div className="mx-auto max-w-xl px-4 py-5 text-center sm:py-8" data-id="element-54" data-mp="c4o665b7dqyb">
        <h2 id="cierre" className="font-display text-2xl font-black text-navy sm:text-4xl" data-id="element-55" data-mp="84e3b1ipjgno">
          Una última oportunidad
        </h2>
        <p className="mt-1.5 text-sm leading-snug text-navy/75" data-id="element-56" data-mp="m2lvkw4sttsi">
          Puedes seguir pasando horas preparando planificaciones, buscando actividades, creando evaluaciones y
          pensando nuevas prácticas cada semana.
        </p>
        <p className="mt-1 text-sm leading-snug text-navy/75" data-id="element-57" data-mp="qvexzdcsoq1f">
          O puedes comenzar hoy a organizar todo ese trabajo con un sistema pensado para acompañarte desde la
          planificación hasta la evaluación.
        </p>
        <p className="mt-1.5 font-display text-sm font-bold text-navy sm:text-base" data-id="element-58" data-mp="zxxznu4ugwm3">
          No necesitas volver a crear todo desde cero.{' '}
          <span className="bg-energy px-1 font-extrabold" data-id="element-59" data-mp="2h3hocnypew5u">Necesitas una estructura que puedas adaptar y reutilizar.</span>
        </p>

        <div className="mt-3 rounded-xl border-2 border-navy bg-white p-4" data-id="element-60" data-mp="2m1sx0vd9j0mh">
          <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto block max-w-[15rem] transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.99]" data-id="element-61" data-mp="2r2gnnfxkxfg6">
            <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-62" data-mp="300soeas5ttmc" />
          </a>
          <p className="mt-2 font-display text-sm font-extrabold text-electric" data-id="element-63" data-mp="34u3wsgcmeigd">⚡ {PRODUCT_NAME}</p>
          <p className="font-display text-sm font-bold text-navy" data-id="element-64" data-mp="39rna9e1hur79">6 Tomos + 5 Bonos</p>
          <p className="mt-1 text-sm text-navy/70" data-id="element-65" data-mp="3est6vmy9yym2">
            Valor de los bonos: <span className="line-through decoration-spark decoration-2" data-id="element-66" data-mp="3isbpud6jczm9">{BONUS_TOTAL}</span>
          </p>
          <p className="font-display text-4xl font-black leading-tight text-navy sm:text-5xl" data-id="element-67" data-mp="1jpembk3tbiw7">
            Hoy: <span className="text-electric" data-id="element-68" data-mp="1eqbghxg0d8n6">{PRICE}</span>
          </p>
          <CtaBlock label="🚀 Sí, quiero acceder ahora" note="Acceso Inmediato • Entrega Digital • Garantía de 7 Días" data-id="element-69" data-mp="1sgexa8w4ca58" />
        </div>
      </div>
    </section>;
}